export default __webpack_public_path__ + "static/media/desktop.4f1d56be.svg";